<div class="page">
  <div class="page-head">
    <div>
      <h2>{{ pageTitle() || 'Payment Lookups' }}</h2>
      <p>Status, mode and payer-type values used across the payment flow.</p>
    </div>
    <p-button label="Add Value" icon="pi pi-plus" (onClick)="openAdd()" />
  </div>

  <div class="card">
    <!-- Category tabs -->
    <div class="cat-tabs">
      @for (c of categories; track c) {
        <button type="button" [class.on]="activeCategory() === c" (click)="selectCategory(c)">
          {{ categoryLabels[c] }}
          <span class="badge">{{ countOf(c) }}</span>
        </button>
      }
    </div>

    <p-table [value]="visible()" [loading]="loading()" dataKey="id" [rows]="10"
      [paginator]="visible().length > 10" [rowsPerPageOptions]="[10, 25, 50]" styleClass="p-datatable-sm" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first}–{last} of {totalRecords}">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 90px">Order</th>
          <th>Code</th>
          <th>Name</th>
          <th>Active</th>
          <th class="ta-r">Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-r>
        <tr>
          <td class="mono">{{ r.displayOrder }}</td>
          <td><span class="mono code">{{ r.typeCode }}</span></td>
          <td class="name">{{ r.typeName }}</td>
          <td>
            <span class="active-toggle" (click)="toggleActive(r)" pTooltip="Click to toggle">
              <p-tag [value]="r.isActive ? 'Active' : 'Inactive'"
                [severity]="r.isActive ? 'success' : 'secondary'" />
            </span>
          </td>
          <td class="ta-r actions">
            <p-button icon="pi pi-pencil" [rounded]="true" [text]="true" severity="secondary"
              pTooltip="Edit" (onClick)="openEdit(r)" />
            <p-button icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger"
              pTooltip="Delete" (onClick)="remove(r)" />
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5">
            <div class="state"><i class="pi pi-inbox"></i>
              <p>No values in {{ categoryLabels[activeCategory()] }} yet.</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<!-- ===================== ADD / EDIT MODAL ===================== -->
<p-dialog [visible]="showModal()" (visibleChange)="showModal.set($event)" [modal]="true" [draggable]="true"
  [resizable]="false" [closable]="true" [dismissableMask]="false"
  [header]="editing() ? 'Edit Lookup Value' : 'New Lookup Value'" styleClass="menu-dialog"
  [style]="{ width: '520px' }" [breakpoints]="{ '520px': '94vw' }">
  <form [formGroup]="form" class="menu-form">
    <div class="field">
      <label>Category <span class="req">*</span></label>
      <p-select formControlName="category" [options]="categories" appendTo="body" />
    </div>

    <div class="grid-2">
      <div class="field">
        <label>Type Code <span class="req">*</span></label>
        <input pInputText type="text" formControlName="typeCode" (input)="onCodeInput()"
          placeholder="UPI" autocomplete="off">
        @if (form.get('typeCode')?.touched && form.get('typeCode')?.invalid) {
          <small class="err">Type code is required</small>
        } @else {
          <small class="hint-muted">Unique within the category.</small>
        }
      </div>
      <div class="field">
        <label>Display Order</label>
        <p-inputNumber formControlName="displayOrder" [min]="0" [showButtons]="true" [useGrouping]="false" />
      </div>
    </div>

    <div class="field">
      <label>Type Name <span class="req">*</span></label>
      <input pInputText type="text" formControlName="typeName" placeholder="UPI">
      @if (form.get('typeName')?.touched && form.get('typeName')?.invalid) {
        <small class="err">Type name is required</small>
      }
    </div>

    <label class="switch-row">
      <p-toggleSwitch formControlName="isActive" />
      <span>Active</span>
    </label>

    <div class="modal-actions">
      <p-button label="Cancel" [outlined]="true" (onClick)="closeModal()" />
      <p-button label="Save" (onClick)="save()" [loading]="saving()" />
    </div>
  </form>
</p-dialog>
